import { useMutation, useQueryClient } from "@tanstack/react-query";
import { getUseIsMaintenanceQueryOptions } from "../../../maintenance-check-point/queries/useIsMaintenanceQuery";
import { TrashScheduleQueryParams } from "../../table/api/getTrashSchedule";
import { getSinglePdf } from "../api/getSinglePdf";

export const useSinglePdfMutation = () => {
  const client = useQueryClient();
  return useMutation(async (building: TrashScheduleQueryParams) => {
    client.prefetchQuery(...getUseIsMaintenanceQueryOptions);
    const blob = await getSinglePdf(building);

    const a = document.createElement("a");
    a.download = "harmonogram.pdf";
    a.href = URL.createObjectURL(blob);

    document.body.appendChild(a);
    a.click();
    a.remove();
  });
};
